import { httpClient } from '../../../../net/httpClient';
import UrlConfig from '../../../../net/UrlConfig';

import {
    RULE_MASTER_QUERY_INPUT_CHANGE,
    START_LOAD_RULE_MASTER,
    LOAD_RULE_MASTER_SUCCESS,
    LOAD_RULE_MASTER_FAILURE,
    INIT_LOAD_RULE_MASTER_ACTION_STATUS,
    SELECT_RULE_MASTER,
    OPEN_ADD_OR_EDIT_RULE_MASTER_MODAL,
    ADD_OR_EDIT_RULE_MASTER_CHANGE_INPUT,
    RESET_ADD_OR_EDIT_RULE_MASTER_MODAL,
    START_SAVE_RULE_MASTER,
    SAVE_RULE_MASTER_SUCCESS,
    SAVE_RULE_MASTER_FAILURE,
    INIT_SAVE_RULE_MASTER_ACTION_STATUS,
    START_DELETE_RULE_MASTER,
    DELETE_RULE_MASTER_SUCCESS,
    DELETE_RULE_MASTER_FAILURE,
    INIT_DELETE_RULE_MASTER_ACTION_STATUS,
    ADD_RULE_MASTER_GRID_TO_PROPS,
} from './ruleMasterConstants';

function formatDate(value) {
    if (!value) {
        return undefined;
    }
    if (value.format) {
        return value.format('YYYY-MM-DD');
    }
    return value;
}

function formatNumber(value) {
    if (value === undefined || value === null || value === '') {
        return undefined;
    }
    const numberValue = Number(value);
    return Number.isNaN(numberValue) ? undefined : numberValue;
}

function buildSaveParams(bean) {
    return {
        id: bean.mode === 'COPY' ? undefined : bean.id,
        ruleId: bean.ruleId,
        status: bean.status,
        category: bean.category,
        country: bean.country,
        fund: bean.fund,
        expType: bean.expType,
        expMeasure: bean.expMeasure,
        expMetric: bean.expMetric,
        assetClass: bean.assetClass,
        reportThreshold: formatNumber(bean.reportThreshold),
        alertThreshold: formatNumber(bean.alertThreshold),
        deadline: bean.deadline,
        effectiveFrom: formatDate(bean.effectiveFrom),
        effectiveTo: formatDate(bean.effectiveTo),
        remarks: bean.remarks,
        lastModifiedDate: bean.lastModifiedDate,
        lastModifiedBy: bean.lastModifiedBy,
    };
}

export function ruleMasterQueryInputChange({ name, value }) {
    return {
        type: RULE_MASTER_QUERY_INPUT_CHANGE,
        payload: { name, value },
    };
}

function startLoadRuleMaster() {
    return { type: START_LOAD_RULE_MASTER };
}

export function loadRuleMaster() {
    return function (dispatch) {
        dispatch(startLoadRuleMaster());
        httpClient
            .get(UrlConfig.QUERY_RULE_MASTER)
            .then(resp => dispatch(loadRuleMasterSuccess(resp)))
            .catch(err => dispatch(loadRuleMasterFailure(err)));
    };
}

function loadRuleMasterSuccess(resp) {
    return {
        type: LOAD_RULE_MASTER_SUCCESS,
        payload: resp,
    };
}

function loadRuleMasterFailure(err) {
    return {
        type: LOAD_RULE_MASTER_FAILURE,
        payload: err,
    };
}

export function initLoadRuleMasterActionStatus() {
    return { type: INIT_LOAD_RULE_MASTER_ACTION_STATUS };
}

export function selectRuleMaster(array) {
    return {
        type: SELECT_RULE_MASTER,
        payload: array,
    };
}

export function openAddOrEditRuleMasterModal(mode, data) {
    return {
        type: OPEN_ADD_OR_EDIT_RULE_MASTER_MODAL,
        payload: { mode, data },
    };
}

export function addOrEditRuleMasterChangeInput({ name, value }) {
    return {
        type: ADD_OR_EDIT_RULE_MASTER_CHANGE_INPUT,
        payload: { name, value },
    };
}

export function resetAddOrEditRuleMasterModal() {
    return { type: RESET_ADD_OR_EDIT_RULE_MASTER_MODAL };
}

function startSaveRuleMaster() {
    return { type: START_SAVE_RULE_MASTER };
}

export function saveRuleMaster(bean) {
    const mode = bean.mode;
    const postURL = mode === 'EDIT' ? UrlConfig.UPDATED_RULE_MASTER : UrlConfig.NEW_RULE_MASTER;
    const requestParams = buildSaveParams(bean);

    return function (dispatch) {
        dispatch(startSaveRuleMaster());
        httpClient
            .post(postURL, requestParams)
            .then(resp => dispatch(saveRuleMasterSuccess(resp)))
            .catch(err => dispatch(saveRuleMasterFailure(err)));
    };
}

function saveRuleMasterSuccess(resp) {
    return {
        type: SAVE_RULE_MASTER_SUCCESS,
        payload: resp,
    };
}

function saveRuleMasterFailure(err) {
    return {
        type: SAVE_RULE_MASTER_FAILURE,
        payload: err,
    };
}

export function initSaveRuleMasterActionStatus() {
    return { type: INIT_SAVE_RULE_MASTER_ACTION_STATUS };
}

function startDeleteRuleMaster() {
    return { type: START_DELETE_RULE_MASTER };
}

export function deleteRuleMaster(rows) {
    return function (dispatch) {
        dispatch(startDeleteRuleMaster());
        if (rows.length === 1) {
            httpClient
                .post(UrlConfig.DELETED_RULE_MASTER, { id: rows[0].id })
                .then(resp => dispatch(deleteRuleMasterSuccess(resp)))
                .catch(err => dispatch(deleteRuleMasterFailure(err)));
            return;
        }

        const idList = rows.map(e => e.id);
        httpClient
            .post(UrlConfig.BATCH_DELETED_RULE_MASTER, idList)
            .then(resp => dispatch(deleteRuleMasterSuccess(resp)))
            .catch(err => dispatch(deleteRuleMasterFailure(err)));
    };
}

function deleteRuleMasterSuccess(resp) {
    return {
        type: DELETE_RULE_MASTER_SUCCESS,
        payload: resp,
    };
}

function deleteRuleMasterFailure(err) {
    return {
        type: DELETE_RULE_MASTER_FAILURE,
        payload: err,
    };
}

export function initDeleteRuleMasterActionStatus() {
    return { type: INIT_DELETE_RULE_MASTER_ACTION_STATUS };
}

export function addRuleMasterGridToProps(grid) {
    return {
        type: ADD_RULE_MASTER_GRID_TO_PROPS,
        payload: grid,
    };
}
